import { Link } from "react-router-dom";
import "./ProgramPage.css";

function ProgramPage() {
    return (
        <div className="program-page">
            {/*<div className="program-hero">
              
               

                <div className="program-hero__media">
                    <div className="program-hero__media-item">
                        <img
                            className="program-hero__img"
                            src="/msprojector.png"
                            alt="Media Projector preview"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>

                <div className="program-hero__actions">
                    <Link to="/contact" className="program-hero__button">
                        Request a demo
                    </Link>
                </div>
            </div>*/}

            <div className="program-content">
               

                <section className="program-section">
                    <h2 className="program-section__title">Key features</h2>
                    <div className="program-grid">
                        <div className="program-card">
                            <h3 className="program-card__title">Compatability</h3>
                            <p className="program-card__text">
                            Support for various operating systems with low level of requirements
                            </p>
                        </div>
                        <div className="program-card">
                            <h3 className="program-card__title">Wide media</h3>
                            <p className="program-card__text">
                                Support for wide spectrum of media content
                            </p>
                        </div>
                        <div className="program-card">
                            <h3 className="program-card__title">Intuitive design</h3>
                            <p className="program-card__text">
                                Intuitive and user-friendly interface for easy navigation and control
                            </p>
                        </div>
                      
                    </div>
                </section>

                <section className="program-section">
                    <h2 className="program-section__title">View the program</h2>
                    <div className="program-preview">
                        <img
                            className="program-preview__image"
                            src="/msprojector.png"
                            alt="Media Service Projector program preview"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </section>

               

                <section className="program-section program-section_cta">
                    <h2 className="program-section__title">Want it like this for your needs?</h2>
                    <p className="program-section__text">
                        Tell us what kind of media show you need, and we will adapt the structure and implementation to your
                        requirements.
                    </p>
                    <div className="program-section_cta__actions">
                        <Link to="/contact" className="program-hero__button program-hero__button_secondary">
                            Discuss the project
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default ProgramPage;

